const platform = "Platform" 

export default platform;